export const EVENT_SIGN_UP_SUCCESS = 'app_signup_success';
export const EVENT_SIGN_IN_SUCCESS = 'app_signin_success';
export const EVENT_STORE_ACTIVATION_STARTED = 'store_activation_started';
export const EVENT_APPLICATION_COMPLETED = 'application_completed';
export const EVENT_STORE_ACTIVATION_SUCCESS = 'store_activated_successfully';
